/** @flow */

import {
  GetReferralList,
  GetReferralListSuccess,
  GetReferralListError,
  GetReferral,
  GetReferralSuccess,
  GetReferralError,
  GetReferralSchema,
  GetReferralSchemaSuccess,
  GetReferralSchemaError,
  NewReferral,
  DuplicateReferralSuccess,
  StartDraftReferralSuccess,
  SetReferralDraft,
  NewReferralAssignments,
  SetReferralAssignments,
  SetReferralEnabled,
  SetReferralStatus,
  SetReferralModalStep,
  SetShowAddReferralModal,
  SetShowEditReferralModal,
  SetShowEditReferralAssignmentsModal,
  SetShowDiscardReferralModal,
  SetShowSubmitReferralModal,
  SetShowDisableReferralModal,
  SetShowCancelReferralModal,
  SetShowCancelDiscardReferralModal,
  SetShowAddReferralAttachmentModal,
  AddReferral,
  AddReferralSuccess,
  AddReferralError,
  UpdateReferral,
  UpdateReferralSuccess,
  UpdateReferralError,
  UpdateReferralAssignments,
  UpdateReferralAssignmentsSuccess,
  UpdateReferralAssignmentsError,
  AddReferralAttachment,
  AddReferralAttachmentSuccess,
  AddReferralAttachmentError,
  DisableReferral,
  DisableReferralSuccess,
  DisableReferralError,
} from "@modules/service/constants/actions";
import * as alertsReducers from "./reducers";
import initialState from "./state";
import type { ReferralState } from "./types";
import { cloneObject } from "@utils/object";

export default (state: ReferralState = initialState, action: Object): ReferralState => {
  const act = {
    [AddReferral]: alertsReducers.onAddReferral,
    [AddReferralSuccess]: alertsReducers.onAddReferralSuccess,
    [AddReferralError]: alertsReducers.onAddReferralError,
    [UpdateReferral]: alertsReducers.onUpdateReferral,
    [UpdateReferralSuccess]: alertsReducers.onUpdateReferralSuccess,
    [UpdateReferralError]: alertsReducers.onUpdateReferralError,
    [UpdateReferralAssignments]: alertsReducers.onUpdateReferralAssignments,
    [UpdateReferralAssignmentsSuccess]: alertsReducers.onUpdateReferralAssignmentsSuccess,
    [UpdateReferralAssignmentsError]: alertsReducers.onUpdateReferralAssignmentsError,
    [AddReferralAttachment]: alertsReducers.onAddReferralAttachment,
    [AddReferralAttachmentSuccess]: alertsReducers.onAddReferralAttachmentSuccess,
    [AddReferralAttachmentError]: alertsReducers.onAddReferralAttachmentError,
    [DisableReferral]: alertsReducers.onDisableReferral,
    [DisableReferralSuccess]: alertsReducers.onDisableReferralSuccess,
    [DisableReferralError]: alertsReducers.onDisableReferralError,

    [GetReferralList]: alertsReducers.onGetReferralList,
    [GetReferralListSuccess]: alertsReducers.onGetReferralListSuccess,
    [GetReferralListError]: alertsReducers.onGetReferralListError,
    [GetReferral]: alertsReducers.onGet,
    [GetReferralSuccess]: alertsReducers.onGetSuccess,
    [GetReferralError]: alertsReducers.onGetError,
    [GetReferralSchema]: alertsReducers.onGetSchema,
    [GetReferralSchemaSuccess]: alertsReducers.onGetSchemaSuccess,
    [GetReferralSchemaError]: alertsReducers.onGetSchemaError,
    [NewReferral]: alertsReducers.onNew,
    [DuplicateReferralSuccess]: alertsReducers.onDuplicateSuccess,
    [StartDraftReferralSuccess]: alertsReducers.onStartDraftSuccess,
    [SetReferralDraft]: alertsReducers.onSetDraft,
    [NewReferralAssignments]: alertsReducers.onNewAssignments,
    [SetReferralAssignments]: alertsReducers.onSetAssignments,
    [SetReferralEnabled]: alertsReducers.onSetEnabled,
    [SetReferralStatus]: alertsReducers.onSetStatus,
    [SetReferralModalStep]: alertsReducers.onSetModalStep,
    [SetShowAddReferralModal]: alertsReducers.onSetShowAddModal,
    [SetShowEditReferralModal]: alertsReducers.onSetShowEditModal,
    [SetShowEditReferralAssignmentsModal]: alertsReducers.onSetShowEditAssignmentsModal,
    [SetShowDiscardReferralModal]: alertsReducers.onSetShowDiscardModal,
    [SetShowSubmitReferralModal]: alertsReducers.onSetShowSubmitModal,
    [SetShowDisableReferralModal]: alertsReducers.onSetShowDisableModal,
    [SetShowCancelReferralModal]: alertsReducers.onSetShowCancelModal,
    [SetShowCancelReferralModal]: alertsReducers.onSetShowCancelModal,
    [SetShowCancelDiscardReferralModal]: alertsReducers.onSetShowCancelDiscardModal,
    [SetShowAddReferralAttachmentModal]: alertsReducers.onSetShowAddReferralAttachmentModal,
  };
  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
